import script from "./CreateProyectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProyectForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateProyectForm.vue?vue&type=style&index=0&id=571c0f32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-571c0f32"]])

export default __exports__